import React from "react";
import './PhotoBook.css'


const PhotoBook = ()=>{
    return(
        <h1>This is photo book page.</h1>
    );
};

export default PhotoBook;